
import { greekSearchFilter } from "@/helpers/data";
import { installationsModule } from '@/store/modules/store-accessor'
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class InstallationUnfinishedCombo extends Vue {
  greekSearchFilter = greekSearchFilter;
    isLoading = false;

    @Prop() readonly installationId: number;
    @Prop() readonly jobId!: number | null;
    @Prop({ default: true }) rightMargin!: boolean; // will set it to false in the add job modal

    get model(): number | null {
        return this.jobId;
    }

    set model(val: number | null) {
        this.$emit('input', val);
    }

    get installationUnfinishedJobs() {
        return installationsModule.installationUnfinishedJobs || [];
    }

    unfinshedJobRule = [
        (val: any) => (!!val) || this.$i18n.t('jobRequired'),
    ];

    async mounted() {
        if (!this.installationId) {
            // installationsModule.clearInstallationUnfinishedJobs();
            return;
        };

        this.isLoading = true;
        await installationsModule.getInstallationUnfinishedJobs(this.installationId);
        this.isLoading = false;
    }

    beforeDestroy() {
        installationsModule.clearInstallationUnfinishedJobs();
    }
}
